<div class="app-container" (scroll)="onWindowScroll();">
    <div class="page-header" id="page-header">
        <mat-toolbar class="main-header">
            <div class="container-fluid">
                <img class="page-logo"
                    src="https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/dp-world-logo-new.svg"
                    alt="DP World" loading="lazy" />
            </div>
        </mat-toolbar>
    </div>
    <div class="page-container w-full h-full">
        <div class="page-content">
            <div class="content-heading-container">
                <div class="background-img-contaier">
                    <picture>
                        <source [srcset]="webpFormatImg.manWithTablet_desktop" media="(min-width: 768px)">
                        <source [srcset]="webpFormatImg.manWithTablet_mobile" media="(max-width: 767px)">
                        <img class="w-full h-auto" [src]="webpFormatImg.manWithTablet_desktop" alt="Banner Image">
                    </picture>
                </div>
                <div class="overlay-container container-fluid">
                    <div class="content-container">
                        <h2 class="text-uppercase">
                            DP World Trade Finance
                        </h2>
                        <p>
                            Creating access to affordable finance for businesses of all sizes
                        </p>
                        <div class="content-action-container">
                            <button mat-button class="apply-now-btn m-b-16"
                                (click)="signUp('Creating access to affordable finance for businesses of all sizes')">Apply
                                Now
                                <img [src]="webpFormatImg.arrowRight_desktop" alt="Apply Now">
                            </button>
                            <button mat-button class="sign-in-btn"
                                (click)="loginToTradeFinance('Creating access to affordable finance')">Sign In
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-light-background container-fluid open-new-doors">
                <div class="flex-container" fxLayout="column">
                    <div class="content-header" fxLayout="row" fxFlex="100">
                        <h2 class="text-uppercase m-0">Opening New Doors</h2>
                    </div>
                    <div class="content-container w-full" fxLayout="row" fxFlex="100">
                        <div class="w-full" fxLayout="column">
                            <div class="m-y-32" fxLayout="row wrap" fxLayoutAlign="space-between start">
                                <p class="m-0" fxFlex="50" fxFlex.lt-sm="100">
                                    Businesses are often unable to gain access to financing when they need it. In
                                    addition
                                    to
                                    that, Financial Institutions continue to suffer from lack of transparency and
                                    accurate
                                    trade data
                                    to enable them to make informed decisions and lend to businesses accordingly.
                                </p>
                                <picture class="img-fluid" fxFlex="50" fxFlex.lt-sm="100"
                                    data-iesrc="https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/People-discussing-graphs-tab.jpg"
                                    data-loaded="true">
                                    <source [srcset]="webpFormatImg.peopleDiscussingGraphs_desktop"
                                        media="(min-width: 415px)">
                                    <source [srcset]="webpFormatImg.peopleDiscussingGraphs_mobile"
                                        media="(max-width: 414px)">
                                    <img alt="People With Graph" loading="lazy">
                                </picture>
                            </div>
                            <div class="m-y-32" fxLayout="row wrap" fxLayoutAlign="space-between start">
                                <picture class="img-fluid" fxFlex="50" fxFlex.lt-sm="100"
                                    data-iesrc="https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/Container-ship-tab.jpg"
                                    data-loaded="true">
                                    <source [srcset]="webpFormatImg.containerShip_desktop" media="(min-width: 415px)">
                                    <source [srcset]="webpFormatImg.containerShip_mobile" media="(max-width: 414px)">
                                    <img alt="Container Ship" loading="lazy">
                                </picture>
                                <div fxFlex="50" fxFlex.lt-sm="100">
                                    <p class="m-t-0">
                                        Our view is that money should never be a barrier for legitimate businesses
                                        wanting
                                        to expand and make their mark in global trade. That's why we've developed DP
                                        World
                                        Trade Finance, to create access to affordable working capital and open
                                        opportunities
                                        for businesses to help global trade flow.
                                    </p>
                                    <div class="content-action-container">
                                        <button mat-button class="apply-now-btn m-b-16"
                                            (click)="signUp('Opening New Doors')">Apply Now
                                            <img [src]="webpFormatImg.arrowRight_desktop" alt="Apply Now">
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-dark-background">
                <div class="flex-container container-fluid" fxLayout="column">
                    <div class="content-header" fxLayout="row wrap" fxFlex="100">
                        <h2 class="text-uppercase m-0">Connecting Worlds</h2>
                        <p class="text-uppercase m-0 m-b-24">
                            Trade Finance sits at the heart of our complete end-to-end logistics offering, connecting
                            businesses across the globe.
                        </p>
                    </div>
                    <div class="content-container w-full">
                        <owl-carousel-o [options]="customOptions">
                            <ng-container *ngFor="let item of connectingWorldCarousel">
                                <ng-template carouselSlide>
                                    <picture>
                                        <source [srcset]="item.imgUrl1" media="(min-width: 415px)">
                                        <source [srcset]="item.imgUrl2" media="(max-width: 414px)">
                                        <img [src]="item.imgUrl1" [alt]="item.alt" loading="lazy">
                                    </picture>
                                    <p class="m-0 m-y-24">
                                        {{item.desc}}
                                    </p>
                                </ng-template>
                            </ng-container>
                        </owl-carousel-o>
                    </div>
                </div>
            </div>
            <div class="content-light-background container-fluid why-and-how">
                <div class="flex-container" fxLayout="column">
                    <div class="content-header" fxLayout="row" fxFlex="100" fxLayoutAlign="space-between start">
                        <h2 class="text-uppercase m-t-0">Why is this important?</h2>
                        <div class="content-action-container">
                            <button mat-button class="apply-now-btn m-b-16"
                                (click)="signUp('Why is this important')">Apply Now
                                <img [src]="webpFormatImg.arrowRight_desktop" alt="Apply Now">
                            </button>
                        </div>
                    </div>
                    <div class="content-container w-full" fxLayout="row" fxFlex="100">
                        <div class="w-full" fxLayout="column">
                            <div class="m-y-32" fxLayout="row wrap" fxLayoutAlign="space-between start">
                                <p class="m-0" fxFlex="50" fxFlex.lt-sm="100">
                                    Small- to medium-sized businesses (SMEs) account for 50% of global trade. However,
                                    only
                                    10% of lending from the current financial ecosystem goes to these companies, usually
                                    at
                                    an excessive cost. This means, the businesses driving half of world trade cannot
                                    access
                                    the finance they need to import, export, or grow.
                                </p>
                                <picture class="img-fluid lozad-picture" fxFlex="50" fxFlex.lt-sm="100"
                                    data-iesrc="https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/Port-tab.jpg"
                                    data-loaded="true">
                                    <source [srcset]="webpFormatImg.port_desktop" media="(min-width: 415px)">
                                    <source [srcset]="webpFormatImg.port_mobile" media="(max-width: 414px)"><img
                                        alt="Port Tab" loading="lazy">
                                </picture>
                            </div>
                            <div class="m-y-32" fxLayout="row wrap" fxLayoutAlign="space-between start">
                                <picture class="img-fluid" fxFlex="50" fxFlex.lt-sm="100"
                                    data-iesrc="https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/City-skyline-tab.jpg"
                                    data-loaded="true">
                                    <source [srcset]="webpFormatImg.citySkyline_desktop" media="(min-width: 415px)">
                                    <source [srcset]="webpFormatImg.citySkyline_mobile" media="(max-width: 414px)"><img
                                        alt="City skyline tab" loading="lazy">
                                </picture>
                                <p class="m-0" fxFlex="50" fxFlex.lt-sm="100">
                                    Financial Institutions traditionally see SMEs as high-risk as they rarely have
                                    substantial credit histories. As a result, there is a $1.7 trillion trade gap. At a
                                    time
                                    of global inflation, this is a vicious circle. Increasing costs are making access to
                                    credit even more important and this block to global trade then acts as an
                                    inflationary
                                    pressure.
                                </p>
                            </div>
                            <div class="m-y-32" fxLayout="row wrap" fxLayoutAlign="space-between start">
                                <p class="m-0" fxFlex="50" fxFlex.lt-sm="100">
                                    Through DP World Trade Finance, however, we are changing that for the better,
                                    providing
                                    opportunities for businesses of all sizes by offering:
                                    <br>
                                    <br>
                                    - Invoice Factoring
                                    <br>
                                    - Invoice Discounting
                                    <br>
                                    - Reverse Factoring
                                    <br>
                                    - Trade Payables Financing
                                    <br>
                                    - Invoice Factoring w/o Recourse
                                    <br>
                                    - Inventory Finance
                                    <br>
                                    - Revolving Credit Facility
                                    <br>
                                    - Supply Chain Finance
                                </p>
                                <picture class="img-fluid" fxFlex="50" fxFlex.lt-sm="100"
                                    data-iesrc="https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/Person-showing-the-exit-door-tab.jpg"
                                    data-loaded="true">
                                    <source [srcset]="webpFormatImg.personShowingTheExitDoor_desktop"
                                        media="(min-width: 415px)">
                                    <source [srcset]="webpFormatImg.personShowingTheExitDoor_mobile"
                                        media="(max-width: 414px)"><img alt="Person exit door" loading="lazy">
                                </picture>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-dark-background">
                <div class="flex-container container-fluid" fxLayout="column">
                    <div class="content-header" fxLayout="row wrap" fxFlex="100">
                        <h2 class="text-uppercase m-0">What are the benefits?</h2>
                    </div>
                    <div class="content-container w-full">
                        <owl-carousel-o [options]="customOptions">
                            <ng-container *ngFor="let item of benefitsCarousel">
                                <ng-template carouselSlide>
                                    <picture>
                                        <source [srcset]="item.imgUrl1" media="(min-width: 415px)">
                                        <source [srcset]="item.imgUrl2" media="(max-width: 414px)">
                                        <img [src]="item.imgUrl1" [alt]="item.alt" loading="lazy">
                                    </picture>
                                    <h3 class="m-0 m-b-16">{{item.heading}}</h3>
                                    <p class="m-0 m-y-24">
                                        {{item.desc1}}
                                        <br>
                                        <br>
                                        {{item.desc2}}
                                    </p>
                                </ng-template>
                            </ng-container>
                        </owl-carousel-o>
                    </div>
                </div>
            </div>
            <div class="content-light-background container-fluid why-and-how">
                <div class="flex-container" fxLayout="column">
                    <div class="content-header" fxLayout="row" fxFlex="100" fxLayoutAlign="space-between start">
                        <h2 class="text-uppercase m-t-0">How does it work?</h2>
                        <div class="content-action-container">
                            <button mat-button class="apply-now-btn m-b-16" (click)="signUp('How does it work')">Apply
                                Now
                                <img [src]="webpFormatImg.arrowRight_desktop" alt="Apply Now">
                            </button>
                        </div>
                    </div>
                    <div class="content-container w-full" fxLayout="row" fxFlex="100">
                        <div class="w-full" fxLayout="column">
                            <div class="m-y-32" fxLayout="row wrap" fxLayoutAlign="space-between start">
                                <p class="m-0" fxFlex="50" fxFlex.lt-sm="100">
                                    We designed DP World Trade Finance to unlock new opportunities for businesses. We
                                    achieve this by giving them a simple digital platform to easily access finance
                                    options
                                    in a way that works for them, rather than needing to jump through the hoops of
                                    prohibitive financial requirements and copious documentation.
                                </p>
                                <picture class="img-fluid" fxFlex="50" fxFlex.lt-sm="100"
                                    data-iesrc="https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/laptop-screen-with-the-calendar-tab.jpg"
                                    data-loaded="true">
                                    <source
                                        srcset="https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/laptop-screen-with-the-calendar-tab.jpg"
                                        media="(min-width: 415px)">
                                    <source
                                        srcset="https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/laptop-screen-with-the-calendar-mobile.jpg"
                                        media="(max-width: 414px)"><img alt="Laptop screen with calendar"
                                        loading="lazy">
                                </picture>
                            </div>
                            <div class="m-y-32" fxLayout="row wrap" fxLayoutAlign="space-between start">
                                <picture class="img-fluid" fxFlex="50" fxFlex.lt-sm="100"
                                    data-iesrc="https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/Star-rating-tab.jpg"
                                    data-loaded="true">
                                    <source
                                        srcset="https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/Star-rating-tab.jpg"
                                        media="(min-width: 415px)">
                                    <source
                                        srcset="https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/Star-rating-mobile.jpg"
                                        media="(max-width: 414px)"><img alt="Star rating tab" loading="lazy">
                                </picture>
                                <p class="m-0" fxFlex="50" fxFlex.lt-sm="100">
                                    To help Financial Institutions assess companies, we provide unique data, visibility,
                                    and
                                    transparency on global trade movements to help them with better risk assessments and
                                    quickly identify viability of new businesses, thereby expediting the entire process
                                    for
                                    all.
                                </p>
                            </div>
                            <div class="m-y-32" fxLayout="row wrap" fxLayoutAlign="space-between start">
                                <p class="m-0" fxFlex="50" fxFlex.lt-sm="100">
                                    We are reducing costs across the supply chain by providing both the capital and the
                                    logistics solution by bundling DP World's financing and logistics capabilities, so
                                    that
                                    businesses can expand their operations.
                                </p>
                                <picture class="img-fluid" fxFlex="50" fxFlex.lt-sm="100"
                                    data-iesrc="https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/Handshake-tab.jpg"
                                    data-loaded="true">
                                    <source
                                        srcset="https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/Handshake-tab.jpg"
                                        media="(min-width: 415px)">
                                    <source
                                        srcset="https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/Handshake-mobile.jpg"
                                        media="(max-width: 414px)"><img alt="Handshake" loading="lazy">
                                </picture>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="apply-now-container">
                <div class="flex-container container-fluid" fxLayout="column">
                    <div class="content-wrapper">
                        <h3 class="m-t-0">Find your ideal solution</h3>
                        <a title="Trade Finance application" (click)="signUp('Find your ideal solution')"
                            class="work-with-us-cta cursor-pointer">
                            <span>CLICK HERE TO APPLY NOW</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="authority-logos-container">
                <div class="flex-container container-fluid" fxLayout="column">
                    <div class="content-wrapper w-full">
                        <owl-carousel-o [options]="authoritiesCarouselOptions">
                            <ng-container *ngFor="let item of authoritiesCarouselData">
                                <ng-template carouselSlide>
                                    <picture class="img-fluid">
                                        <source [srcset]="item.imgUrl1" media="(min-width: 415px)">
                                        <source [srcset]="item.imgUrl2" media="(max-width: 414px)">
                                        <img class="img-fluid" [src]="item.imgUrl1" [alt]="item.alt" loading="lazy">
                                    </picture>
                                </ng-template>
                            </ng-container>
                        </owl-carousel-o>
                    </div>
                </div>
            </div>
            <div class="contact-us-container">
                <div class="flex-container container-fluid" fxLayout="column">
                    <div class="content-wrapper">
                        <h1>CONTACT US</h1>
                        <h4>For further information or&nbsp;to speak to a member of our customer service team, we'd love
                            to hear from you:</h4>
                        <p>Call:&nbsp;<a href="tel: +971 4 825 90 90" target="_blank">+97148259090</a></p>
                        <p>
                            <span> Email Global:&nbsp; </span>
                            <a href="mailto:global.tradefinance@dpworld.com" style="font-size: 19px;"
                                target="_self">global.tradefinance@dpworld.com
                            </a>
                        </p>
                        <h4></h4>
                        <p>
                            <span>Email UAE:&nbsp; </span>
                            <a href="mailto:uae.tradefinance@dpworld.com" style="font-size: 19px;"
                                target="_self">uae.tradefinance@dpworld.com
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <div class="disclaimer-container">
                <div class="flex-container container-fluid" fxLayout="column">
                    <div class="content-wrapper">
                        <p class="text-center separator">
                            ---------------------------------------------------------------------------------------------------------------
                        </p>
                        <h3>DISCLAIMER</h3>
                        <h6>DP World Trade Finance is a fintech platform (“the Platform”) owned by DP World Logistics
                            FZE
                            which brings together importers, exporters, and logistics companies from around the world
                            (who
                            seek trade finance) together with financial institutions and other providers of trade
                            finance.
                        </h6>
                        <h6>In order to access the Platform, you must confirm your jurisdiction. For UAE based persons
                            (including the Dubai International Financial Centre (DIFC)), the Platform is operated by DP
                            World Financial Services Limited. For those who are operating outside the United Arab
                            Emirates,
                            you will receive your services through the Platform operated by DP World Service Limited,
                            and
                            entity incorporated in Cayman Islands.</h6>
                        <h6>DP World Financial Services Limited is an Authorized firm incorporated in the DIFC and
                            regulated
                            by the Dubai Financial Services Authority (DFSA). For persons outside the UAE, the Platform
                            is
                            operated by DP World Services Limited, an entity incorporated in the Cayman Islands. You
                            will
                            receive services and enter into an agreement with either DP World Financial Services Limited
                            (DIFC) or DP World Services Limited (Cayman), subject to the jurisdiction you are located.
                        </h6>
                        <h6 class="sub-header"><strong>DP World Financial Services Limited</strong></h6>
                        <h6>DP World Financial Services Limited is incorporated in the Dubai International Financial
                            Centre
                            (DIFC) and is regulated by the Dubai Financial Services Authority (DFSA) to offer the
                            financial
                            services of 'Arranging Credit' and “Providing Credit” for client who is based in the UAE.
                            These
                            Financial Services are available through the Platform it operates. The Platform is operated
                            by
                            DP World Financial Services Limited whose registered office is at 811, Level 8, Burj Daman,
                            DIFC, Al Moustaqbal Street, Dubai, United Arab Emirates.</h6>
                        <h6 class="sub-header"><strong>DP World Services Limited</strong></h6>
                        <h6>DP World Services Limited offers the service of 'Arranging Credit' to clients who are
                            outside of
                            the United Arab Emirates through its Platform. For any client who is interested to obtain
                            the
                            financial service of providing credit, you can submit your application on DP World Trade
                            Finance. DP World Services Limited is incorporated in Cayman Island and is an exempted
                            company
                            with its registered office at c/o Walkers Corporate Limited, 190 Elgin Avenue, George Town,
                            Grand Cayman Islands KY1-9008, Cayman Islands.</h6>
                    </div>
                </div>
            </div>
            <div class="page-footer">
                <div class="footer-image-container container-fluid" fxLayout="column">
                    <div class="footer-links m-y-auto m-r-auto">
                        <ul fxFlex="100" fxLayout="row wrap" fxLayoutAlign="space-between start">
                            <li class="p-b-8 p-r-24" fxFlex.sm="50" fxFlex.xs="100">
                                <a class="cursor-pointer" (click)="openGeneralPoliciesTab('privacy-policy')">Privacy
                                    Policy</a>
                            </li>
                            <li class="p-b-8 p-r-24" fxFlex.sm="50" fxFlex.xs="100">
                                <a class="cursor-pointer"
                                    (click)="openGeneralPoliciesTab('terms-and-conditions')">General
                                    Terms and Conditions</a>
                            </li>
                            <li class="p-b-8 p-r-24" fxFlex.sm="50" fxFlex.xs="100">
                                <a class="cursor-pointer" (click)="openGeneralPoliciesTab('customer-disclaimer')">Key
                                    Information Document</a>
                            </li>
                            <li class="p-b-8 p-r-24" fxFlex.sm="50" fxFlex.xs="100">
                                <a class="cursor-pointer" (click)="openGeneralPoliciesTab('contact-us')">Contact Us</a>
                            </li>
                            <li class="p-b-8 p-r-24" fxFlex.sm="50" fxFlex.xs="100">
                                <a class="cursor-pointer" (click)="openGeneralPoliciesTab('about-us')">About Us</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>